import { FileText } from 'lucide-react';
import { openStoredDocument } from '@/lib/openDocument.js';
import TestBadge from '@/components/shared/TestBadge.jsx';

// THE DOCUMENTS HOME'S ROWS (paperwork-1 D8, L1b-B3): each document by its derived name (the server's, never built here),
// the file it was filed from beside it, and Open (the logged download door, by its documents id). A replaced document says
// so. Used by the account Documents list, the aircraft's documents and the search page; a row the server marks test (the
// search with Show test on) carries the TEST badge.
export default function DocumentListRows({ rows, empty = 'No documents.', showPolicy = false }) {
  if (!rows || rows.length === 0) return <p className="text-xs italic text-text-dim">{empty}</p>;
  return (
    <ul className="divide-y divide-border" data-document-rows>
      {rows.map((r) => (
        <li key={r.id} data-document-row={r.id} className="flex flex-wrap items-center gap-x-2 gap-y-0.5 py-1.5 text-xs">
          <FileText size={12} strokeWidth={1.5} className="shrink-0 text-text-dim" />
          <span className="min-w-0 flex-1 break-words text-text">{r.name}</span>
          {r.is_test === true ? <TestBadge isTest /> : null}
          {showPolicy && r.policy ? <span className="font-mono text-[11px] text-text-muted">{[r.policy.policy_number, r.policy.term_years].filter(Boolean).join(', ')}</span> : null}
          {r.superseded ? <span className="text-text-dim">replaced by a newer copy</span> : null}
          {r.original_filename && r.original_filename !== r.name ? <span className="basis-full pl-5 text-[11px] text-text-dim">filed from {r.original_filename}</span> : null}
          <button type="button" onClick={() => openStoredDocument(r.id)} aria-label={`Open ${r.name}`}
            className="ml-auto min-h-[32px] rounded-md border border-border-strong px-2.5 py-0.5 text-[11px] text-text hover:bg-surface-strong">
            Open
          </button>
        </li>
      ))}
    </ul>
  );
}
